module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.81f751c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Regular.woff2
// module id = 6Gah
// module chunks = 0